import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { pageLeftThunk } from '@redux/analytics/analyticsThunks';
import { PageType } from '@redux/analytics/analyticsTypes';
import { DualPane } from '../../components/DualPane/DualPane';
import { DevicePane } from '../../components/DualPane/Panes/DevicePane/DevicePane';
import { ForgotPasswordEmailPane } from '../../components/DualPane/Panes/ForgotPasswordEmailPane/ForgotPasswordEmailPane';

interface Props {
  pageLeft: Function;
}

const ForgotPasswordEmail: React.FC<Props> = ({ pageLeft }) => (
  <DualPane
    pageLeft={pageLeft}
    pageType={PageType.FORGOT_PASSWORD_EMAIL}
    leftPane={<DevicePane />}
    rightPane={(loadingState, handleExternalRouting, handleError) => (
      <ForgotPasswordEmailPane loadingState={loadingState} handleExternalRouting={handleExternalRouting} handleError={handleError} />
    )}
  />
);

const connectRedux = connect(
  () => ({}),
  (dispatch: Function) => ({
    pageLeft: async (pageType: PageType) => {
      return dispatch(pageLeftThunk(pageType));
    }
  })
);

export default compose(connectRedux)(ForgotPasswordEmail);
